import { createVNode as i, mergeProps as l } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/LoadingFilled.js";
import n from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return i(n, l(t, {
    icon: a
  }), null);
};
o.displayName = "LoadingFilled";
o.inheritAttrs = !1;
export {
  o as default
};
